
<div class="panelAddUsers">
  <div class="custom-container">
    <loading [isFixed]="true" [isAbsolute]="false" [isLoading]="isLoading" [isFullSize]="true"></loading>
    <mat-icon color="primary" class="back-arrow" [routerLink]="'/settingsAdmin'">arrow_back</mat-icon>
    <form [formGroup]="formGroup" #myFormUserEdit>
      <mat-card>
              <mat-card-title class="card-title">Agregar Usuario</mat-card-title>
              <mat-card-content>
          <mat-card class="paper-card general-data">
            <mat-card-header>
              <mat-card-subtitle><span class="card-subtitle">Datos Generales</span></mat-card-subtitle>
            </mat-card-header>
            <mat-card-content>
              <div class="input-row">
                <div [ngClass]="{'col-5': this.mobileQuery.matches}" class="custom-input-container">
                  <mat-form-field>
                    <mat-label>Nombre *</mat-label>
                    <input formControlName="firstName" matInput placeholder="Nombre" required />
                  </mat-form-field>
                  <span>{{  getError("firstName")  }}</span>
                </div>
                <div [ngClass]="{'col-3': this.mobileQuery.matches}" class="custom-input-container">
                  <mat-form-field>
                    <mat-label>Apellido Paterno</mat-label>
                    <input formControlName="lastName" matInput placeholder="Apellido Paterno" />
                  </mat-form-field>
                  <span>{{ getError("lastName") }}</span>
                </div>
                <div [ngClass]="{'col-3': this.mobileQuery.matches}" class="custom-input-container">
                  <mat-form-field>
                    <mat-label>Apellido Materno</mat-label>
                    <input formControlName="secondLastName" matInput placeholder="Apellido Materno" />
                  </mat-form-field>
                  <span>{{ getError("secondLastName") }}</span>
                  <div *ngIf="!formGroup.controls.secondLastName.valid && formGroup.controls.secondLastName.value === ''">
                    Este campo es obligatorio
                  </div>
                </div>
              </div>
              <div class="input-row">
                <div class="col-12 custom-input-container">
                  <mat-form-field class="width-90">
                    <mat-label>Email *</mat-label>
                    <input formControlName="email" matInput placeholder="Email" [readonly]="readonly" (focus)="readOnly()" required />
                  </mat-form-field>
                  <span>{{ getError("email") }}</span>
                </div>
              </div>
              <div class="input-row">
                <div [ngClass]="{'col-3': this.mobileQuery.matches}" class="custom-input-container">
                  <mat-form-field>
                    <mat-label>Password *</mat-label>
                    <input autocomplete="new-password"  formControlName="password" matInput [type]="hidePassword ? 'password' : 'text'" placeholder="Sin Cambios" [readonly]="readonly" (focus)="readOnly()" />
                    <button mat-icon-button matSuffix (click)="hidePassword = !hidePassword" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hidePassword">
                      <mat-icon>{{hidePassword ? 'visibility_off' : 'visibility'}}</mat-icon>
                    </button>
                  </mat-form-field>
                  <span>{{ getError("password") }}</span>
                </div>
                <div [ngClass]="{'col-3': this.mobileQuery.matches}" class="custom-input-container">
                  <mat-form-field>
                    <mat-label>Confirm Password *</mat-label>
                    <input [ngStyle]="{ '-webkit-text-security': hidePassword ? 'disc' : 'none' }" formControlName="confirmPassword" matInput [type]="hidePassword ? 'password' : 'text'" placeholder="Sin Cambios" [readonly]="readonly" (focus)="readOnly()" />
                    <button mat-icon-button matSuffix (click)="hidePassword = !hidePassword" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hidePassword">
                      <mat-icon>{{hidePassword ? 'visibility_off' : 'visibility'}}</mat-icon>
                    </button>
                  </mat-form-field>
                  <span>{{ getError("confirmPassword") }}</span>
                </div>
                <div [ngClass]="{'col-2': this.mobileQuery.matches}" class="custom-input-container">
                  <mat-form-field>
                    <mat-label>UserName Citronella</mat-label>
                    <input formControlName="userNameCitronella" matInput placeholder="Usuario Citronella" />
                  </mat-form-field>
                  <span>{{ getError("userNameCitronella") }}</span>
                  <span style="color: black;"> * se volverá obligatorio </span>
                </div>
              </div>

              <div class="input-row">
                <div [ngClass]="{'col-2': this.mobileQuery.matches}" class="custom-input-container slider-container">
                  <mat-slide-toggle formControlName="isUserAPP" >
                    Usuario de App
                  </mat-slide-toggle>
                </div>
              </div>
            </mat-card-content>
          </mat-card>

          <mat-card class="paper-card add-customer">
            <mat-card-header class="card-header">
              <mat-card-subtitle>
                  <span class="card-subtitle">Agregar Clientes</span>
              </mat-card-subtitle>
              
              <div>
                <div class="custom-input-container">
                  <button class="btnMore" mat-icon-button [matMenuTriggerFor]="clienteMenu"
                    aria-label="Example icon-button with a menu" matTooltip="Acciones" matTooltipPosition="above">
                    <img src="/assets/img/icon_puntitos.png" width="25px">
                  </button>
                  <mat-menu #clienteMenu="matMenu">
                    <button mat-menu-item (click)="agregarCliente()">
                      <span>Agregar</span>
                      <mat-icon matSuffix color="primary">add_circle</mat-icon>
                    </button>
                    <button mat-menu-item (click)="quitarCliente()">
                      <span>Quitar último</span>
                      <mat-icon matSuffix color="warn">remove_circle</mat-icon>
                    </button>
                  </mat-menu>
                </div>
              </div>
            </mat-card-header>
            <mat-card-content>
              <!-- control para el cliente default -->
              <customer-control [clientNumber]="0" (customerData)="assignCustomerData($event)"></customer-control>
              <!-- control para los clientes extra -->
              <div *ngFor="let i of extraCustomerCount">
                <customer-control [clientNumber]="i" (customerData)="assignCustomerData($event)" (deleteCustomer)="DeleteCustomerIndex($event)"></customer-control>
              </div>
            </mat-card-content>
          </mat-card>

          <!-- <mat-card class="paper-card" *ngIf="_isVinsSelected">
            <mat-card-header>
              <mat-card-subtitle>VIN Asignados</mat-card-subtitle>
            </mat-card-header>
            <mat-card-content>
              <app-admin-vin-control [client]="this.formGroup.controls['client'].value" [IdentifierListInput]="_stringIdentifiers" (IdentifierList)="updateIdentifiers($event)"></app-admin-vin-control>
            </mat-card-content>
          </mat-card> -->
        </mat-card-content>
        <mat-card-actions>
          <button class="form-control btn-primary btn-agregar" (click)="onSubmit(formGroup.value)" [disabled]="formGroup.invalid" mat-button>
            Agregar
          </button>
          <!-- <div class="row">
            <div class="col-md-10">
              <a type="submit"
                >
              </a>
            </div>
            <div class="col-md-2">
              <a href="/#/users"
                ><button type="button" class="form-control btn-warning btn-agregar" mat-button>
                  Cancelar
                </button>
              </a>
            </div>
          </div> -->
        </mat-card-actions>
      </mat-card>
    </form>
  </div>
</div>